import {
  PAGE_GROUPS,
  PAGE_GROUP_CHANGED,
} from '@web-platform/shared-universal-constants/src/pageGroups';
import { GLOBAL } from 'saddlebag-browser';

import type { PageGroup } from '@web-platform/shared-universal-constants/src/pageGroups';
import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { PageGroupState } from '@web-platform/shared-universal-types/src/redux/state/appInitial/pageGroup';

const $window: Window = GLOBAL.getWindow();

const INITIAL_STATE: PageGroupState = {
  name: $window?.__internal?.initialPageGroup || PAGE_GROUPS.UNKNOWN_PAGE_GROUP,
};

export function pageGroupReducer(
  state: PageGroupState = INITIAL_STATE,
  action: Action,
): PageGroupState {
  switch (action.type) {
    case PAGE_GROUP_CHANGED:
      return {
        ...state,
        name: action.payload.name,
      };

    default:
      return state;
  }
}

export const getPageGroupName = (state: PageGroupState): PageGroup => state.name;
